// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ComponentImage_imageContainer__cTjEq","image":"ComponentImage_image__3Cc0S"};